export const redFlagsConstants = {
    errors: {
        fetchFailed: "Failed to load red flags.",
        countFailed: "Failed to load red flags count.",
        fetchDetailFailed: "Failed to load red flag details.",
        createFailed: "Failed to create red flag.",
        updateFailed: "Failed to update red flag.",
        deleteFailed: "Failed to delete red flag.",
    },
    messages: {
        createSuccess: "Red flag created successfully.",
        updateSuccess: "Red flag updated successfully.",
        deleteSuccess: "Red flag deleted successfully.",
    },
};
